import type { Experience } from "./runtime";

export const DEFAULT_LOCALE = "ko-KR" as const;
export const RESERVED_LOCALES = ["ko-KR", "en"] as const;

export function appTitle(experience: Experience): string {
  if (experience === "ADMIN") return "RS 진로교육 관리자";
  if (experience === "CENTER") return "RS 진로교육 센터";
  if (experience === "WALLET") return "RS LIFE PASSPORT";
  return "RS 자격증명 검증";
}

export function appSubtitle(experience: Experience): string {
  if (experience === "ADMIN") return "관리 영역 · 기관 / 심리검사 / 정책 / 자격증명";
  if (experience === "CENTER") return "운영 영역 · 학교 / 교사 / 학생";
  if (experience === "WALLET") return "나의 진로성장 · 경험 / 목표 / Life Stamp";
  return "공개 검증 · 학생 민감정보 비노출";
}

export function environmentLabel(value: string): string {
  if (value === "DEVELOPMENT") return "개발환경";
  if (value === "STAGING") return "검증환경";
  if (value === "PRODUCTION") return "운영환경";
  return value;
}

export function roleLabel(roleKey: string): string {
  if (roleKey === "PLATFORM_ADMIN") return "플랫폼 관리자";
  if (roleKey === "REGIONAL_ADMIN") return "지역 관리자";
  if (roleKey === "SCHOOL_ADMIN") return "학교 관리자";
  if (roleKey === "CAREER_TEACHER") return "진로교사";
  return roleKey;
}

export function experienceLabel(experience: string): string {
  if (experience === "ADMIN") return "관리자";
  if (experience === "CENTER") return "센터";
  if (experience === "WALLET") return "Life Passport";
  if (experience === "VERIFY") return "자격증명 검증";
  return experience;
}

export function accessReasonText(reason: string): string {
  if (reason === "WORKSPACE_REQUIRED") return "계속하려면 학교 작업공간을 선택하세요.";
  if (reason === "PLATFORM_ADMIN_REQUIRED") return "이 화면은 플랫폼 관리자만 이용할 수 있습니다.";
  if (reason === "ADMIN_SCOPE_REQUIRED") return "이 기관 범위를 관리할 수 있는 지역 또는 플랫폼 관리자 권한이 없습니다.";
  if (reason === "WORKSPACE_ROLE_REQUIRED") return "이 작업공간을 이용할 수 있는 활성 권한이 없습니다.";
  if (reason === "LEARNER_SELF_REQUIRED") return "이 계정은 활성 학생 프로필과 연결되어 있지 않습니다.";
  if (reason === "UNKNOWN_EXPERIENCE") return "등록되지 않은 서비스 영역입니다.";
  return "이 서비스 영역을 이용할 권한이 없습니다.";
}

export function credentialStatusLabel(
  status: string,
  valid?: boolean,
  expiresAt?: string | null
): string {
  if (valid) return "유효";
  if (
    status === "ACTIVE" &&
    expiresAt &&
    new Date(expiresAt).getTime() <= Date.now()
  ) return "만료";
  if (status === "ACTIVE") return "활성";
  if (status === "REVOKED") return "취소";
  if (status === "EXPIRED") return "만료";
  return status;
}
